import React, { useState } from 'react';
import { Menu, X} from 'lucide-react';
import '../styles/Header.css';

const Header = ({ toggleTheme, currentTheme }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="dark-header">
      <div className="header-content">
        <div className="dark-logo-container" onClick={() => scrollToSection('hero')}>
          <h1 className="logo-text">REVERA</h1>
        </div>
        
        <nav className={`dark-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <a onClick={() => scrollToSection('hero')} className="dark-nav-link">Ana Sayfa</a>
          <a onClick={() => scrollToSection('project')} className="dark-nav-link">Proje</a>
          <a onClick={() => scrollToSection('team')} className="dark-nav-link">Ekip</a>
          <a onClick={() => scrollToSection('contact')} className="dark-nav-link">İletişim</a>
        </nav>
        
        <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;

